module.exports = __webpack_public_path__ + "img/upload.43d27feb.svg";